var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4,7.2L7.3,9.4C7.1,9.6,7,9.8,7,10c0,0.2,0.1,0.4,0.2,0.6l2.2,2.2 C9.6,12.9,9.8,13,10,13c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.2-0.3,0.2-0.6s-0.1-0.4-0.2-0.6l-0.7-0.8h2.7c0.2,0,0.4-0.1,0.6-0.2 c0.2-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.2-0.4-0.2-0.6-0.2H9.8l0.8-0.8c0.2-0.2,0.2-0.3,0.2-0.6 c0-0.2-0.1-0.4-0.2-0.6C10.4,7.1,10.2,7,10,7S9.6,7.1,9.4,7.2z M10,1.7c1.2,0,2.2,0.2,3.2,0.7s1.9,1,2.6,1.8s1.3,1.6,1.8,2.6 s0.7,2.1,0.7,3.2c0,1.2-0.2,2.2-0.7,3.2c-0.4,1-1,1.9-1.8,2.6s-1.6,1.3-2.6,1.8s-2.1,0.7-3.2,0.7c-1.2,0-2.2-0.2-3.2-0.7 c-1-0.4-1.9-1-2.6-1.8s-1.3-1.6-1.8-2.6c-0.4-1-0.7-2.1-0.7-3.2c0-1.2,0.2-2.2,0.7-3.2c0.4-1,1-1.9,1.8-2.6s1.6-1.3,2.6-1.8 C7.8,1.9,8.8,1.7,10,1.7z M10,3.3C8.2,3.3,6.6,4,5.3,5.3C4,6.6,3.3,8.2,3.3,10c0,1.8,0.6,3.4,1.9,4.7c1.3,1.3,2.9,1.9,4.7,1.9 c1.8,0,3.4-0.6,4.7-1.9c1.3-1.3,1.9-2.9,1.9-4.7c0-1.8-0.6-3.4-1.9-4.7C13.4,4,11.8,3.3,10,3.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleLeft);
export default __webpack_public_path__ + "static/media/ArrowCircleLeft.61f5086811a6d5dc3dfd7020fe1980f7.svg";
export { ForwardRef as ReactComponent };